<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="158"
      card
      color="#fff"
    >
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link
                :to="{ name: props.item.routeName }"
                :is="props.item.disabled ? 'span' : 'router-link'"
              >
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12 class="mb-3">
          <BoxIcon padding="8px" class="mr-3">
            <v-icon medium color="white">devices</v-icon>
          </BoxIcon>
          <h1 style="display: inline">Dispositivos</h1>
        </v-flex>
      </v-layout>
      <v-speed-dial
        absolute
        bottom
        left
        direction="bottom"
        open-on-hover
        transition="scale-transition"
        style="bottom: 0"
      >
        <template v-slot:activator>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn
                  dark
                  icon
                  small
                  fab
                  color="gradiente"
                  @click="
                    () => {
                      selectedDevice = undefined
                      modals.isUpdateModalType = false
                      modals.showCreateUpdateDevice = true
                    }
                  "
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Dar de alta un dispositivo.</span>
          </v-tooltip>
        </template>
      </v-speed-dial>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <div class="border-container bg-white pa-1">
          <v-layout row wrap pa-4>
            <v-flex xs12 md6>
              <div
                v-if="devices.length === 0"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 500px;
                "
              >
                Sin dispositivos registrados
              </div>
              <DeviceCard
                v-for="(device, index) in devices"
                :device="device"
                :selected="
                  selectedDevice !== undefined &&
                  selectedDevice.id === device.id
                "
                :position="
                  devices.length === 1
                    ? 'single'
                    : index === devices.length - 1
                    ? 'bottom'
                    : index === 0
                    ? 'top'
                    : 'middle'
                "
                @update="
                  () => {
                    selectedDevice = device
                    modals.isUpdateModalType = true
                    modals.showCreateUpdateDevice = true
                  }
                "
                @delete="
                  () => {
                    selectedDevice = device
                    modals.showConfirmDeleteDevice = true
                  }
                "
                @click="selectDevice(device)"
              />
            </v-flex>
            <v-flex xs12 md6>
              <div class="border-container">
                <div
                  v-if="devices.length === 0 || selectedDevice === undefined"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 500px;
                  "
                >
                  Sin accesos registrados
                </div>
                <div v-if="selectedDevice !== undefined">
                  <DeviceAccessesCard
                    v-for="access in selectedDevice.accesses"
                    :access="access"
                    @update="
                      () => {
                        selectedAccess = access
                        modals.isUpdateModalType = true
                        modals.showCreateUpdateAccess = true
                      }
                    "
                    @delete="
                      () => {
                        selectedAccess = access
                        modals.showConfirmDeleteAccess = true
                      }
                    "
                  />
                  <div
                    :style="{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height:
                        selectedDevice.accesses === undefined ? '500px' : '',
                    }"
                  >
                    <v-btn
                      style="border-radius: 6px"
                      small
                      color="primary"
                      @click="
                        () => {
                          selectedAccess = undefined
                          modals.isUpdateModalType = false
                          modals.showCreateUpdateAccess = true
                        }
                      "
                    >
                      Agregar accesos
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
    <ConfirmDeleteDevice
      :show="modals.showConfirmDeleteDevice"
      title="¿Seguro que desea eliminar este dispositivo?"
      description="Al eliminarlo, también se eliminarán los accesos que tiene asignados"
      cancel-text="No, Cancelar"
      ok-text="Si, eliminar"
      @change="onConfirmDeleteDevice"
    />
    <ConfirmDeleteAccess
      :show="modals.showConfirmDeleteAccess"
      title="¿Seguro que desea eliminar este acceso?"
      description="Al eliminarlo, el código QR del acceso ya no será válido."
      cancel-text="No, Cancelar"
      ok-text="Si, eliminar"
      @change="onConfirmDeleteAccess"
    />
    <ModalDevice
      v-model="modals.showCreateUpdateDevice"
      :device="selectedDevice"
      :is-update="modals.isUpdateModalType"
      @created="onCreateUpdateDelete"
      @updated="onCreateUpdateDelete"
    />
    <ModalDeviceAccesses
      v-model="modals.showCreateUpdateAccess"
      :access="selectedAccess"
      :is-update="modals.isUpdateModalType"
      :device-id="selectedDevice !== undefined ? selectedDevice.id : undefined"
      @created="onCreateUpdateDelete"
      @updated="onCreateUpdateDelete"
    />
    <Error v-model="modals.showError" :text="modals.errorText"> </Error>
    <Success v-model="modals.showSuccess" :text="modals.succesText"> </Success>
    <Loading v-model="modals.showLoading" text="Cargando..." />
  </div>
</template>

<script>
import Error from '../../../../Dialogs/Error.vue'
import Loading from '../../../../Dialogs/Loading.vue'
import Success from '../../../../Dialogs/Success.vue'
import {
  default as ConfirmDeleteAccess,
  default as ConfirmDeleteDevice,
} from '../../../../Dialogs/confirm_new_ui.vue'
import BoxIcon from '../../../../generic/boxIcon.vue'
import DeviceAccessesCard from '../components/DeviceAccessesCard.vue'
import DeviceCard from '../components/DeviceCard.vue'
import ModalDevice from '../components/ModalDevice.vue'
import ModalDeviceAccesses from '../components/ModalDeviceAccesses.vue'

export default {
  components: {
    ModalDevice,
    BoxIcon,
    DeviceCard,
    DeviceAccessesCard,
    ConfirmDeleteDevice,
    ConfirmDeleteAccess,
    ModalDeviceAccesses,
    Error,
    Loading,
    Success,
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'Colegios',
        disabled: false,
        routeName: 'Colleges',
      },
      {
        text: 'Dispositivos',
        disabled: true,
        routeName: 'CollegeDevices',
      },
    ],
    devices: [],
    selectedDevice: undefined,
    selectedAccess: undefined,
    modals: {
      isUpdateModalType: false,

      showCreateUpdateDevice: false,

      showCreateUpdateAccess: false,

      showConfirmDeleteDevice: false,
      showConfirmDeleteAccess: false,

      showLoading: false,

      showSuccess: false,
      succesText: '',

      showError: false,
      errorText: '',
    },
  }),
  async mounted() {
    await this.getDevices()
  },
  methods: {
    async onCreateUpdateDelete() {
      await this.getDevices()
      this.selectedDevice = this.devices.find(
        (e) => e.id === this.selectedDevice.id
      )
    },
    async getDevices() {
      try {
        let { data } = await this.$store.dispatch(
          'colleges/getRaspberry',
          this.$route.params.id
        )
        this.devices = data
      } catch (error) {
        console.log(error)
      }
    },
    selectDevice(device) {
      this.selectedDevice = device
    },
    async onConfirmDeleteAccess(e) {
      this.modals.showConfirmDeleteAccess = false
      if (e === true) {
        await this.deleteAcccess()
      }
    },
    async onConfirmDeleteDevice(e) {
      if (e === true) {
        await this.deleteDevice()
      }

      this.modals.showConfirmDeleteDevice = false
    },
    async deleteDevice() {
      this.modals.showLoading = true
      try {
        await this.$store.dispatch(
          'colleges/deleteRaspberry',
          this.selectedDevice.id
        )
        this.modals.succesText = 'Dispositivo eliminado exitosamente'
        this.modals.showLoading = false
        this.modals.showSuccess = true
        this.onCreateUpdateDelete()
      } catch (error) {
        this.modals.showLoading = false
        console.log(error)
        const errors = {
          400: 'No se encontró un raspberry por el id proporcionado.',
        }

        this.modals.showError = true
        this.modals.errorText =
          errors[error.response.status] || 'Error al eliminar dispositivo'
      }
    },
    async deleteAcccess() {
      this.modals.showLoading = true
      try {
        await this.$store.dispatch('colleges/deleteAccess', [
          this.selectedDevice.id,
          this.selectedAccess.id,
        ])
        this.modals.succesText = 'Acceso eliminado exitosamente'
        this.modals.showLoading = false
        this.modals.showSuccess = true
        this.onCreateUpdateDelete()
      } catch (error) {
        this.modals.showLoading = false
        console.log(error)
        const errors = {
          404: 'No se encontró el acceso proporcionado.',
        }

        this.modals.showError = true
        this.modals.errorText =
          errors[error.response.status] || 'Error al eliminar acceso'
      }
    },
  },
}
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}
.border-container {
  padding: 1px;
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
}
/* reset global css */
::v-deep .v-btn {
  text-transform: initial;
}
/* generic */
.bg-white {
  background-color: white;
}
</style>
